const getNavigatorLanguage = () => {
  if (navigator.language.indexOf('-') > -1) {
    return navigator.language.split('-')[0];
  }

  return navigator.language;
};

const getNeededLanguage = () => {
  const path = window.location.pathname;
  const navigatorLanguage = getNavigatorLanguage();
  const lang = path.split('/')[1];

  if (!lang) {
    return navigatorLanguage;
  }

  if (lang === 'kr') {
    return 'ko';
  }

  if (lang !== 'ko' && lang !== 'zh' && lang !== 'en' && lang !== 'ja') {
    return navigatorLanguage;
  }

  return lang;
};

export { getNavigatorLanguage, getNeededLanguage };
